import { useContext } from 'react';
import { storeContext } from '../context';

export const useStoreContext = () => {
  const context = useContext(storeContext);
  if (!context) {
    throw new Error('useStoreContext must be used inside StoreProvider');
  }

  return context;
};
